import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    background: 'linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)',
    border: '1px solid rgba(226, 232, 240, 0.9)',
    borderRadius: 16,
    overflow: 'hidden',
  },
  header: {
    borderBottom: '1px solid rgba(226, 232, 240, 0.8)',
    padding: theme.spacing(2.5, 3, 2),
  },
  title: {
    color: '#0f172a',
    fontWeight: 700,
    letterSpacing: '-0.02em',
  },
  titleRow: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
  },
  titleIcon: {
    color: '#2563eb',
    fontSize: 22,
  },
  subtitle: {
    color: '#64748b',
    marginTop: theme.spacing(0.5),
  },
  statsSection: {
    padding: theme.spacing(2, 2, 0),
  },
  statsGrid: {
    display: 'grid',
    gap: theme.spacing(1.5),
    gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))',
  },
  statCard: {
    alignItems: 'center',
    background: 'linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)',
    border: '1px solid rgba(226, 232, 240, 0.9)',
    borderRadius: 14,
    boxShadow: '0 10px 30px rgba(15, 23, 42, 0.05)',
    display: 'flex',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.75),
  },
  statIconWrap: {
    alignItems: 'center',
    borderRadius: 12,
    display: 'flex',
    height: 48,
    justifyContent: 'center',
    minWidth: 48,
  },
  statAccentBlue: {
    background: 'rgba(37, 99, 235, 0.12)',
    color: '#1d4ed8',
  },
  statAccentIndigo: {
    background: 'rgba(79, 70, 229, 0.12)',
    color: '#4338ca',
  },
  statAccentRed: {
    background: 'rgba(239, 68, 68, 0.12)',
    color: '#dc2626',
  },
  statAccentCyan: {
    background: 'rgba(8, 145, 178, 0.12)',
    color: '#0e7490',
  },
  statIcon: {
    fontSize: 22,
  },
  statContent: {
    minWidth: 0,
  },
  statLabel: {
    color: '#64748b',
    display: 'block',
    fontSize: '0.68rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    lineHeight: 1.2,
  },
  statValue: {
    color: '#0f172a',
    fontWeight: 800,
    lineHeight: 1.2,
    marginTop: theme.spacing(0.35),
  },
  statNote: {
    color: '#64748b',
    fontSize: '0.8rem',
    marginTop: theme.spacing(0.25),
  },
  tableSection: {
    padding: theme.spacing(0, 2, 2),
  },
  tableContainer: {
    boxShadow: '0 10px 30px rgba(15, 23, 42, 0.05)',
    overflowX: 'auto',
  },
  table: {
    minWidth: 980,
  },
  headerRow: {
    backgroundColor: '#eff6ff',
  },
  headerCell: {
    color: '#ffffff',
    fontSize: '0.8rem',
    fontWeight: 800,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
  },
  bodyRow: {
    transition: 'background-color 180ms ease, transform 180ms ease',
    '&:nth-child(even)': {
      backgroundColor: 'rgba(248, 250, 252, 0.7)',
    },
    '&:hover': {
      backgroundColor: 'rgba(239, 246, 255, 0.85)',
    },
  },
  taskCell: {
    fontWeight: 700,
    color: '#1d4ed8',
    whiteSpace: 'nowrap',
  },
  subjectCell: {
    color: '#0f172a',
    fontWeight: 600,
    maxWidth: 220,
  },
  typeCell: {
    color: '#1e293b',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  dateCell: {
    color: '#334155',
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  requesterAvatar: {
    background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
    boxShadow: '0 8px 20px rgba(37, 99, 235, 0.22)',
    fontSize: '0.9rem',
    fontWeight: 700,
    height: 34,
    width: 34,
  },
  assigneeGroup: {
    justifyContent: 'flex-start',
  },
  assigneeAvatar: {
    backgroundColor: '#dbeafe',
    border: '2px solid #ffffff',
    color: '#1d4ed8',
    fontSize: '0.82rem',
    fontWeight: 700,
    height: 32,
    width: 32,
  },
  overdueBadge: {
    background: 'rgba(239, 68, 68, 0.12)',
    borderRadius: 999,
    color: '#b91c1c',
    display: 'inline-flex',
    fontSize: '0.82rem',
    fontWeight: 700,
    minWidth: 36,
    justifyContent: 'center',
    padding: theme.spacing(0.4, 1),
  },
  pagination: {
    borderTop: '1px solid rgba(226, 232, 240, 0.8)',
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
  },
  userContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
}));
